var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#BFBFBF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6549_72450)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-1116 -354)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1086 -188C-1086 -193.523 -1081.52 -198 -1076 -198H54C59.5228 -198 64 -193.523 64 -188V906H-1086V-188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1062,
    y: -16,
    width: 1102,
    height: 56,
    rx: 20,
    fill: "#E5B85C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11.9961 10.9999C11.4485 10.9999 11.0045 11.4439 11.0045 11.9916V15.5846C11.0045 15.7219 11.0043 15.8611 11.0041 16.002L11.0041 16.004C11.0041 16.554 11.45 16.9999 12 16.9999C12.5534 16.9999 13.0025 16.552 13.0039 15.9986C13.0043 15.8406 13.0045 15.7026 13.0045 15.5846V11.9916C13.0045 11.4439 12.5605 10.9999 12.0128 10.9999H11.9961ZM12 7.02173C11.3048 7.02173 10.75 7.58137 10.75 8.27173C10.75 8.9669 11.3096 9.52173 12 9.52173C12.6952 9.52173 13.25 8.96208 13.25 8.27173C13.25 7.57656 12.6904 7.02173 12 7.02173Z",
    fill: "#E0A906"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6549_72450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-1116 -354)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFill);
export default __webpack_public_path__ + "static/media/alert-fill.cc6c8e19.svg";
export { ForwardRef as ReactComponent };